export default "__VITE_ASSET__CaQlaUYq__"